module.exports = "/images/lines-9.jpg";